import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'clsx'
import { Link } from 'react-router-dom'
import Icon from '../Icon'
import styles from './Button.css'

const propTypes = {
  /** Custom CSS Classes */
  className: PropTypes.string,
  /** onClick handler */
  onClick: PropTypes.func,
  /** Text on the button */
  label: PropTypes.string,
  /** Element inside the button */
  children: PropTypes.any, // eslint-disable-line
  /** Determines the style of the button * */
  kind: PropTypes.oneOf(['primary', 'secondary', 'tertiary', 'danger']),
  /** Custom style prop */
  style: PropTypes.object,
  /** if href provided to button, button will be a link */
  href: PropTypes.string,
  /** target of href */
  target: PropTypes.string,
  /** name of icon */
  icon: PropTypes.string,
  /** Size of Icon. Takes number or pixel value. Example size={30} */
  iconSize: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  /** Custom Icon props */
  iconProps: PropTypes.object,
}

const defaultProps = {
  kind: 'primary',
  iconSize: 20,
  iconProps: {}
}

/**
 * Protip: Use `kind` prop to set styles of button
 */
export default function Button({
  onClick,
  label,
  children,
  className,
  kind,
  style,
  href,
  to,
  target,
  icon,
  iconSize,
  iconProps,
  ...props
}) {
  const text = label || children

  const classes = classNames(
    'component-button',
    className,
    styles.button,
    styles[kind],
    {
      [styles.hasIcon]: icon
    }
  )

  let iconRender
  if (icon) {
    const restProps = {
      ...iconProps,
      size: iconProps.size || iconSize,
      name: icon || iconProps.icon,
      className: classNames(styles.icon, iconProps.className)
    }
    iconRender = (
      <Icon {...restProps} />
    )
  }
  // Make link if href supplied
  if (href) {
    return (
      <a
        className={classes}
        href={href}
        target={target}
        onClick={onClick}
        style={style}
      >
        {iconRender}
        <span className={styles.buttonText}>{text}</span>
      </a>
    )
  }
  if (to) {
    return (
      <Link
        className={classes}
        to={to}
        target={target}
        onClick={onClick}
        style={style}
      >
        {iconRender}
        <span className={styles.buttonText}>{text}</span>
      </Link>
    )
  }

  return (
    <button className={classes} onClick={onClick} style={style} {...props}>
      {iconRender}
      <span className={styles.buttonText}>
        {text}
      </span>
    </button>
  )
}

Button.propTypes = propTypes
Button.defaultProps = defaultProps
